import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import { RiPhoneLockLine } from 'react-icons/ri';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';
import { ButtonRow, FormInput, Loader, useAuth, AuthLayout } from '@omnigenbiodata/ui';
import { AUTH_CHALLENGES } from '../../../../core/constants/aws.constant';

function MultiFactor() {
  const { t } = useTranslation(['portal', 'validation']);
  const { hasError, isBusy, challengeName, user, setupCode, completeSetupMfa, completeMfa } = useAuth();

  const validationSchema = yup.object().shape({
    otp: yup.string().required(t('otpRequired', { ns: 'validation' })),
  });

  const formik = useFormik({
    initialValues: { otp: '' },
    validationSchema,
    onSubmit: (values: any) => {
      const { otp } = values;
      if (challengeName === AUTH_CHALLENGES.MFA_SETUP) {
        completeSetupMfa(otp);
      } else {
        completeMfa(otp);
      }
    },
  });

  return (
    <AuthLayout
      title={t('mfa.title')}
      text={t('mfa.text')}
      hasError={hasError}
      errorTitle={t('alerts.mfaFailed.title')}
      errorText={t('alerts.mfaFailed.text')}
      dmsa
    >
      <form onSubmit={formik.handleSubmit}>
        <Box mb={4}>
          <FormInput
            error={formik.errors.otp}
            name="otp"
            label={t('forms.otp')}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            touched={formik.touched.otp}
            value={formik.values.otp}
            startAdornment={<RiPhoneLockLine />}
          />
        </Box>
        {setupCode && user && (
          <>
            <div style={{ textAlign: 'center', marginBottom: 90 }}>
              <QRCode
                value={'otpauth://totp/DMSA_STAFF:' + user.username + '?secret=' + setupCode + '&issuer=DMSA_STAFF'}
              />
            </div>
            <span id="setupCode" style={{ opacity: 0 }}>
              {setupCode}
            </span>
          </>
        )}
        <ButtonRow forwardColor="primary" forwardLabel={t('buttons.confirm')} buttonSize="large" />
      </form>
      <Loader isVisible={isBusy} label={t('loaders.check') as string} />
    </AuthLayout>
  );
}

export default MultiFactor;
